import axios from "axios";
import { HOST_URL } from "../constants/Constants";

export const getAllAssets = async () => {
  const data = await axios
    .get(HOST_URL + "/assets/getAllAssets")
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};

export const getAllRegionAssets = async (regionCode, assetFilterKey) => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/assets/getAllRegionAssets",
    withCredentials: true,
    params: { regionCode, assetFilterKey },
  });
  return data.data;
};

export const getMWHAssets = async () => {
  const data = await axios({
    method: "get",
    url: HOST_URL + "/assets/getMWHAssets",
    withCredentials: true,
  });
  return data.data;
};
